module.exports = __webpack_public_path__ + "files/hotel_directory_users_upload.238dac8.xlsx";